module.exports = __webpack_public_path__ + "img/8f8263b.png";